.schema-not-set-warning {
  padding: 0px 20px;
}

.ocrtest {
  width: 100%;
  height: 100%;
}
